const ClippedText = ({ text, maxLength = 50 }) => {
  const clippedText =
    text?.length > maxLength ? text.slice(0, maxLength) + "..." : text

  return text ? <span title={text}>{clippedText}</span> : ""
}

export default ClippedText
